import { GlForm, GlFormGroup, GlFormRadioGroup, GlModal } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { uniqueId } from 'lodash-es';
import { s__, __ } from '~/locale';
import csrf from '~/lib/utils/csrf';
import { CATEGORY_OPTIONS } from '~/abuse_reports/components/constants';
export default {
    name: 'WorkItemAbuseModal',
    csrf,
    i18n: {
        title: __('Report abuse to administrator'),
        label: s__('ReportAbuse|Why are you reporting this user?')
    },
    modal: {
        id: uniqueId('work-item-abuse-modal-'),
        actionPrimary: {
            text: __('Next'),
            attributes: {
                variant: 'confirm'
            }
        },
        actionSecondary: {
            text: __('Cancel'),
            attributes: {
                variant: 'default'
            }
        }
    },
    CATEGORY_OPTIONS,
    components: {
        GlForm,
        GlFormGroup,
        GlFormRadioGroup,
        GlModal
    },
    inject: {
        reportAbusePath: {
            default: ''
        }
    },
    props: {
        reportedUserId: {
            type: Number,
            required: true
        },
        reportedFromUrl: {
            type: String,
            required: false,
            default: ''
        },
        showModal: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'close-modal'
    ],
    data () {
        return {
            selectedOption: CATEGORY_OPTIONS[0].value
        };
    },
    methods: {
        closeModal () {
            this.$emit('close-modal');
        },
        submitForm () {
            this.$refs.form.$el.submit();
        }
    }
};
